export default {
  path: '/product_datas',
  name: 'product_datas',
  component: () => import('../components/productdata/Layout'),
  redirect: { name: 'ProducDataList' },
  children: [
    /*
    {
      name: 'ToolHeadSubList',
      path: '',
      component: () => import('../views/toolheadsub/List')
    },
    {
      name: 'ToolHeadSubCreate',
      path: 'new',
      component: () => import('../views/toolheadsub/Create')
    },
    {
      name: 'ToolHeadSubUpdate',
      path: ':id/edit',
      component: () => import('../views/toolheadsub/Update')
    },

    {
      name: 'ToolHeadSubShow',
      path: ':id',
      component: () => import('../views/toolheadsub/Show')
    }
    */
  ]
};
